import { Dispatch, SetStateAction } from 'react';
import EmailIcon from '@/assets/icons/envelop.svg?react';
import styles from './InputText.module.scss';

interface IProps {
    type: string;
    placeholderText: string;
    value: string;
    setValue?: Dispatch<SetStateAction<string>>;
}

const InputText = ({ type, placeholderText, value, setValue }: IProps) => {
    const getInputMode = () => {
        if (type === 'email') return 'email';
        if (type === 'number') return 'numeric';
        return 'text';
    };

    const handleChange = (e: any) => {
        if (setValue) setValue(e.target.value);
    };

    return (
        <div className={styles.inputContainer}>
            <input
                type={type}
                inputMode={getInputMode()}
                placeholder={placeholderText}
                className={styles.input}
                value={value}
                onChange={handleChange}
                required
            />
            <EmailIcon className={styles.icon} />
        </div>
    );
};

export default InputText;
